import React from 'react';
import './ErrorBoundary.css';

/**
 * ErrorBoundary component for graceful error handling
 * Catches JavaScript errors anywhere in child component tree
 * and displays a fallback UI instead of crashing
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to an error reporting service
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    this.setState({ errorInfo });
    
    // You can also send this error to your analytics or monitoring service
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // Render custom fallback UI
      return (
        <div className="error-boundary" dir="auto">
          <div className="error-content">
            <h2>{this.props.fallbackHeading || 'משהו השתבש'}</h2>
            <p>{this.props.fallbackMessage || 'מתנצלים על התקלה. אנחנו עובדים על תיקון הבעיה.'}</p>
            {this.props.showResetButton && (
              <button 
                className="error-reset-button" 
                onClick={() => {
                  this.setState({ hasError: false, error: null, errorInfo: null });
                  if (this.props.onReset) this.props.onReset();
                }}
              >
                נסה שוב
              </button>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
